import { RouteRecordRaw } from 'vue-router';

// 取引履歴関連
export const transactionRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Transaction',
    component: () => import('@/components/pages/transaction/index.vue'),
    path: '/transaction',
    meta: {
      title: '取引履歴',
      requiredAuthority: 'TRANSACTIONS',
    },
  },
  {
    name: 'TransactionId',
    component: () => import('@/components/pages/transaction/detail/index.vue'),
    path: '/transaction/:id',
    meta: {
      title: '取引履歴詳細',
      requiredAuthority: 'TRANSACTIONS',
    },
  },
];
